// extracted by mini-css-extract-plugin
module.exports = {"content":"edit_content__h7OY4","title":"edit_title__2G1eU"};